import ApiClientBuffer from './ApiClientBuffer';

export const getMelody = () => ApiClientBuffer.get('/melody');
